import React from 'react';

import { chessgroundSetup } from '../util/chessgroundHelper';

class Board extends React.Component {
  constructor(props) {
    super(props);
    this.board = React.createRef();
  }

  componentDidMount() {
    chessgroundSetup(this.board.current);
  }

  render() {
    return (
      <div className="board-editor">
        <div className="brown cg-wrap">
          {<div ref={this.board} />}
        </div>
      </div>
    );
  }
}

export default Board;
